import { Link } from "react-router-dom";
import { ArrowLeft, LogIn } from "lucide-react";
import { PageShell } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function LoginPage() {
  const { loading, isAdmin } = useAuth();

  const handleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/quotes";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <PageShell>
      <section className="container py-14">
        <Button asChild variant="ghost" className="mb-8 rounded-sm px-0 text-sm text-muted-foreground hover:bg-transparent hover:text-foreground">
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Back to overview
          </Link>
        </Button>
        <div className="mx-auto max-w-2xl">
          <p className="eyebrow">Owner / admin sign-in</p>
          <h1 className="mt-3 font-display text-4xl font-medium tracking-tight text-foreground sm:text-5xl">
            Restricted area
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground">
            This sign-in is restricted to the Spiral Beyond Compliance owner. Client
            users, prospects and testers cannot access the internal pricing register or
            quote builder. All authorisation is enforced server-side on every request.
          </p>
          <div className="mt-8 rounded-sm border border-border bg-card p-6">
            <p className="text-sm text-muted-foreground">
              Signed in and authorised as owner? Head to{" "}
              <Link to="/admin/quotes" className="underline decoration-border underline-offset-4 hover:text-foreground">
                /admin/quotes
              </Link>
              .
            </p>
            <div className="mt-6">
              <Button
                type="button"
                onClick={handleSignIn}
                className="rounded-sm"
                data-testid="owner-signin-btn"
                disabled={loading || isAdmin}
              >
                <LogIn className="h-4 w-4" />
                {isAdmin ? "Already signed in" : "Sign in with Emergent Google"}
              </Button>
            </div>
          </div>
          <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
            The owner email is validated against a fixed canonical account. Any other
            Google account will authenticate but receive no admin access.
          </p>
        </div>
      </section>
    </PageShell>
  );
}
